import { ResponseElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Response extends ResponseElement {
  /**
   * OpenAPI 3.2: Brief summary of the response.
   */
  get summary() {
    return this.get('summary');
  }
  set summary(summary) {
    this.set('summary', summary);
  }
}
export default Response;